import React, { PropsWithChildren } from "react";

interface Props {
  title?: string;
}

const FooterSection = ({ title, children }: PropsWithChildren<Props>) => {
  return (
    <div className="flex-1 flex flex-col gap-1.5">
      <h2 className="text-l border-b border-grey-fog-1">{title}</h2>
      {children}
    </div>
  );
};

export default FooterSection;
